import { MaterialIcon } from 'mol-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { theme } from 'styled';
import {
    Container,
    Icon,
    IconsContainer,
    Link,
    Subtitle,
    Text,
    TextContainer,
    Title
} from './styled';
const { textColor } = theme;

const ListItem = ({
    actions,
    height,
    link,
    onDelete,
    onEdit,
    onLinkClick,
    onView,
    subtitle,
    text,
    title,
    titleColor
}) =>
    <Container height={ height }>
        <TextContainer>
            {
                !!title &&
                <Title color={ titleColor }>
                    { title }
                    {
                        !!link && onLinkClick &&
                        <Link onClick={ onLinkClick }>
                            { link }
                        </Link>
                    }
                </Title>
            }
            {
                !!subtitle &&
                <Subtitle>
                    { subtitle }
                </Subtitle>
            }
            {
                !!text &&
                <Text>
                    { text }
                </Text>
            }
        </TextContainer>
        <IconsContainer>
            {
                actions.includes('VIEW') &&
                <Icon onClick={ onView }>
                    <MaterialIcon color={ textColor } icon="remove_red_eye" />
                </Icon>
            }
            {
                actions.includes('EDIT') &&
                <Icon onClick={ onEdit }>
                    <MaterialIcon color={ textColor } icon="edit" />
                </Icon>
            }
            {
                actions.includes('DELETE') &&
                <Icon onClick={ onDelete }>
                    <MaterialIcon color={ textColor } icon="delete" />
                </Icon>
            }
        </IconsContainer>
    </Container>
;

ListItem.propTypes = {
    actions: PropTypes.array,
    height: PropTypes.string,
    link: PropTypes.string,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func,
    onLinkClick: PropTypes.func,
    onView: PropTypes.func,
    subtitle: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    titleColor: PropTypes.string
};

export default ListItem;
